import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import i18next from "i18next";

const ZENDESK_URL = "https://static.zdassets.com/ekr/snippet.js";
const ZENDESK_KEY = "9eecccfa-f22e-4e8a-9d08-9ab7ed4bdd0f";
const ZENDESK_ID = "ze-snippet";

/**
 * docs at: https://developer.zendesk.com/api-reference/widget/core/#commands
 */
const Chat = () => {
    const [zendeskOpen, setZendeskOpen] = useState(
        !!document.getElementById(ZENDESK_ID)
    );
    const initialMount = useRef(true);

    const onScriptLoaded = () => {
        if (!initialMount.current) {
            return;
        }
        initialMount.current = true;
        window.zE("webWidget:on", "close", closeChatWidget);
        window.zE("webWidget:on", "open", () => setZendeskOpen(true));

        openChatWidget();
    };

    const openChatWidget = () => {
        window.zE("webWidget", "show");
        window.zE("webWidget", "open");
    };

    const closeChatWidget = () => {
        window.zE("webWidget", "hide");
        setZendeskOpen(false);
    };

    const openZendesk = () => {
        if (null !== document.getElementById(ZENDESK_ID)) {
            return openChatWidget();
        }
        const script = document.createElement("script");
        script.id = ZENDESK_ID;
        script.src = `${ZENDESK_URL}?key=${ZENDESK_KEY}`;
        script.addEventListener("load", onScriptLoaded);
        document.body.appendChild(script);
    };

    if (zendeskOpen) {
        return null;
    }

    return <ChatBubble onClick={openZendesk} />;
};

const ChatBubble = ({ onClick }) => (
    <div id="custom-chat-bubble" onClick={onClick}>
        <svg
            id="Raw"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256.00098 256.00098"
        >
            <rect width="256" height="256" fill="none" />
            <path
                d="M77.35142,201.87677l-32.2031,27.07116a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H82.49925A8,8,0,0,0,77.35142,201.87677Z"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="16"
            />
            <circle cx="128.00049" cy="128.00098" r="12" />
            <circle cx="80.00049" cy="128.00098" r="12" />
            <circle cx="176.00049" cy="128.00098" r="12" />
        </svg>
        <span className="custom-chat-bubble__content">
            {i18next.t("chat.chat")}
        </span>
    </div>
);

ChatBubble.propTypes = {
    onClick: PropTypes.func,
};

export default Chat;
